export default __webpack_public_path__ + "static/media/(37)-min.1ea3c68c.JPG";